import React, { useState } from 'react';
import { useEffect } from 'react';
import { CheckSquare, Square } from "react-feather";

import './FormCheckSquare.scss';

function FormCheckSquare(props) {
	const { disabled, onChange, ...squareProps } = props;
	const [checked, setChecked] = useState(props.checked);

	useEffect(() => {
		setChecked(props.checked);
	}, [props.checked])

	const onClick = checkedValue => {
		if (disabled) return;
		setChecked(checkedValue);
		if (onChange) onChange(checkedValue);

	};

	const statusColor = (disabled) ? 'disabled' : 'enabled';
	if(checked) {
		return <CheckSquare {...squareProps} onClick={() => onClick(false)} className={statusColor}/>;
	} else {
		return <Square {...squareProps} onClick={() => onClick(true)} className={statusColor}/>;
	}
}

export default FormCheckSquare;
